import { RiCarouselView } from "react-icons/ri";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Land Experiences Slider",
  name: "landExperiencesSlider",
  type: "object",
  icon: RiCarouselView,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "landExperiences",
      title: "Land Experiences",
      type: "array",
      of: [
        {
          type: "reference",
          to: [{ type: "landExperience" }]
        }
      ]
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      landExperiences: "landExperiences"
    },
    prepare(selection) {
      const { title, landExperiences } = selection;
      return {
        title: multilingualStringPreview(title) || "([Collection] Slider)",
        subtitle: `${landExperiences.length || 0} Land Experiences`
      };
    }
  }
});
